import React, { AnchorHTMLAttributes, DetailedHTMLProps } from "react";
import {
    createStyles,
    Fab,
    Theme,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { ArrowRightAlt } from "@material-ui/icons";

type BannerButtonProps = WithStyles<typeof styles> & {
    arrowLeft: boolean;
    link: (
        props: DetailedHTMLProps<
            AnchorHTMLAttributes<HTMLAnchorElement>,
            HTMLAnchorElement
        >
    ) => JSX.Element;
    text: string;
};

const styles = (theme: Theme) =>
    createStyles({
        arrowIconLeft: { transform: "rotate(180deg)" },
        fabButton: {
            [theme.breakpoints.down("sm")]: {
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6)
            },
            [theme.breakpoints.down("xs")]: {
                paddingLeft: theme.spacing(4),
                paddingRight: theme.spacing(4)
            },
            "&:hover": { backgroundColor: "rgba(199, 139, 24, 1)" },
            backgroundColor: "rgba(0, 0, 0, 1)",
            paddingLeft: theme.spacing(8),
            paddingRight: theme.spacing(8),
            color: "rgba(220, 154, 29, 1)"
        }
    });

class BannerButton extends React.PureComponent<BannerButtonProps, {}> {
    public render() {
        return (
            <Fab
                size="large"
                variant="extended"
                color="secondary"
                className={this.props.classes.fabButton}
                component={this.props.link}
            >
                {this.props.arrowLeft && (
                    <ArrowRightAlt
                        className={this.props.classes.arrowIconLeft}
                    />
                )}
                {this.props.text}
                {!this.props.arrowLeft && <ArrowRightAlt />}
            </Fab>
        );
    }
}

export default withStyles(styles)(BannerButton);
